import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AdminService } from "../admin.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-admin-user-admin-reset-password",
  templateUrl: "./admin-user-admin-reset-password.component.html",
  styleUrls: ["./admin-user-admin-reset-password.component.css"],
})
export class AdminUserAdminResetPasswordComponent implements OnInit {
  hide = false;
  token: any;
  resetPasswordForm: FormGroup;
  loading: boolean = false;
  isReadonly: boolean = true;
  constructor(
    private matdialogref: MatDialogRef<AdminUserAdminResetPasswordComponent>,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private services: AdminService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.resetPasswordForm = this.formBuilder.group({
      password: ["", [Validators.required, Validators.pattern('^\\S*$')]],
      confirmPassword: ["", [Validators.required, Validators.pattern('^\\S*$')]],
    }, { validators: this.passwordMatchValidator });
  }

  passwordMatchValidator(g: FormGroup) {
    return g.get('password')?.value === g.get('confirmPassword')?.value
      ? null : { 'mismatch': true };
  }

  preventSpace(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.preventDefault();
    }
  }

  close() {
    this.matdialogref.close();
  }
  updatePassword() {
    if (this.resetPasswordForm.invalid) {
      if (this.resetPasswordForm.hasError('mismatch')) {
        this.snackBar.open("Passwords do not match", "Fail", { duration: 3000 });
      } else {
        this.snackBar.open("Please enter a valid password without spaces", "Fail", { duration: 3000 });
      }
      return;
    }
    const addPassObj = {
      password: this.resetPasswordForm.value.password,
    };
    this.services.AddPassword(addPassObj, this.token, this.data._id).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.snackBar.open("Password updated successfully", "Success", {
            duration: 5000,
          });
          this.matdialogref.close();
        }
      },
      (error) => {
        if (error.status == 403 || 401) {
          this.router.navigateByUrl("admin/login");
          localStorage.clear();
        }
        if (error.error.message === "jwt malformed || jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
}
